export default {
  bugReport: 'Nahlásiť chybu',
  descriptionPlaceholder: 'Popíšte chybu',
  attachments: 'Prílohy',
  sendConfirmation: {
    summary: 'Hlásenie chyby bolo odoslané',
    detail: 'Dostali sme hlásenie o chybe a čoskoro vás kontaktujeme.',
  },
};
